export default "__VITE_ASSET__6cffcc93__"